import React, { Component, ComponentType } from 'react';
import ObjectBlock          from '../ObjectBlock/ObjectBlock';

import { toJS } from 'mobx';

interface MyProps {
  quizObjects: Array<JSX.Element>,
}

class ObjectList extends Component<any, any> {
  constructor(props: any) {
    super(props)
  }

  render() {
    var component = this;

    return (
      <div className="padding-left-1">
        {this.props.quizObjects.map((objectElement: any, i: number) =>
          <div key={i}>{objectElement}</div>
        )}
      </div>
    );
  }
}



export default ObjectList;
